<span class="align-center">
  <mat-icon>check_circle_outline</mat-icon> &nbsp; &nbsp; {{ data?.message }}
  {{ showSuccessfully === true ? "successfully" : "" }}
</span>
